
export class EmployeeTokenConsumptionReportRequest {
    fromDate: string;
    toDate: string;
    departmentId?: number;
    freebieCategory?: string;

    /**
     * 
     * @param fromDate 
     * @param toDate 
     * @param departmentId 
     * @param freebieCategory 
     */
    constructor(fromDate: string, toDate: string, departmentId?: number, freebieCategory?: string) {
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.departmentId = departmentId;
        this.freebieCategory = freebieCategory;
    }
}
